module.exports = __webpack_public_path__ + "img/bxs_lock.4a11c56a.svg";